// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1793421711214
      var cssReload = require("/private/workspaces/smart-life/smart-life-admin/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  